import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { DataService } from '../core/data.service';
import { DaysOfWeek, EndCondition, FormMode, PatternType, Period, RecurrencyStatus, WeekOfMonth } from '../shared/enums';
import { RecurrencyPattern } from '../shared/models/recurrency-pattern';

const TIMEZONE_STORAGE_KEY: string = 'timeZone';

@Component({
  selector: 'app-recurrent-pattern',
  templateUrl: 'recurrent-pattern.component.html',
  styleUrls: ['recurrent-pattern.component.css'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class RecurrentPatternComponent implements OnInit {
  @Input() recurrencyPatternModel: RecurrencyPattern;
  enum = { FormMode, Period, PatternType, EndCondition };
  recurrencyStatus;
  periods;
  days;
  dayGroups;
  weeks;
  model;
  vehicles;
  timeZones;
  formMode: FormMode;

  constructor(
    private dataService: DataService,
    private notificationsService: NotificationsService
  ) {
    let recurrencyStatus = Object.keys(RecurrencyStatus).map(s => ({ text: s, value: RecurrencyStatus[s] })).filter(d => typeof d.value === 'number');
    let days = Object.keys(DaysOfWeek).map(d => ({ text: d, value: DaysOfWeek[d] })).filter(d => typeof d.value === 'number');
    let weeks = Object.keys(WeekOfMonth).map(w => ({ text: w, value: WeekOfMonth[w] })).filter(w => typeof w.value === 'number');
    let periods = Object.keys(Period).map(p => ({ text: p, value: Period[p] })).filter(p => typeof p.value === 'number');

    this.recurrencyStatus = recurrencyStatus;
    this.days = days.filter(d => d.value && d.value.toString(2).match(/1/g).length === 1);
    this.dayGroups = days.filter(d => d.value && this.days.indexOf(d) === -1);
    this.weeks = weeks.filter(w => !/^None$/.test(w.text));
    this.periods = periods.filter(p => /^Week|Month$/.test(p.text)).map(p => ({ ...p, text: `${p.text}(s)` }));
  }

  get defaultTimeZone() {
    let stored = localStorage.getItem(TIMEZONE_STORAGE_KEY);
    return this.timeZones && this.timeZones.map(t => t.id).filter(id => id === stored)[0] || 'UTC';
  }

  set defaultTimeZone(value) {
    if (value) {
      localStorage.setItem(TIMEZONE_STORAGE_KEY, value);
    } else {
      localStorage.removeItem(TIMEZONE_STORAGE_KEY);
    }
  }

  ngOnInit() {
    this.formMode = this.recurrencyPatternModel ? FormMode.Edit : FormMode.Create;
    this.dataService.getTimeZones().then(timeZones => {
      this.timeZones = timeZones;
      if (this.formMode === FormMode.Create) {
        this.recurrencyPatternModel.timeZoneName = this.defaultTimeZone;
      }
    });
  }

  onPeriodChange = (value) => {
    if (value === Period.Week) {
      this.recurrencyPatternModel = {
        ...this.recurrencyPatternModel,
        patternType: PatternType.DaysOfWeek,
        daysOfWeek: DaysOfWeek.None
      };
    } else if (value === Period.Month) {
      this.recurrencyPatternModel = {
        ...this.recurrencyPatternModel,
        patternType: PatternType.DayOfMonth,
        dayOfMonth: 1,
        weekOfMonth: WeekOfMonth.First,
        daysOfWeek: DaysOfWeek.Monday
       };
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/recurrence/recurrent-pattern.component.ts